module.exports = __webpack_public_path__ + "static/img/David.Evans.7680aa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David.Evans.jpg
// module id = zUbt
// module chunks = 0